import script from "./MenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./MenuItem.vue?vue&type=style&index=0&id=438fface&lang=scss"

const __exports__ = script;

export default __exports__